'use client';
import React from 'react';
import Hero from '@/app/blog/chicago-o-hare-international-airport-ord/hero';
import Contetn from './content';
import Table from '@/app/blog/chicago-o-hare-international-airport-ord/tableData';
import Contetn2 from '@/app/blog/chicago-o-hare-international-airport-ord/content2';
import Table2 from './table2';
import Backforward from '../backforward';
import Twako from '../../componenets/tawko2';
import Navbar from '@/app/componenets/Navbar';
import Footer from '@/app/componenets/Footer';
function page() {
  return (
    <div>
      <title>Chicago O’Hare International Airport – A Guide</title>
      <meta
        name="description"
        content="Everything you need to know about Chicago O’Hare Airport to make your trip more organized and stress-free! Read this guide to learn about the layout, parking & much more."
      />

      {/* <!-- Facebook Meta Tags --> */}
      <meta property="og:url" content="https://www.prestigeride.com" />
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Chicago O’Hare International Airport – A Guide"
      />
      <meta
        property="og:description"
        content="Everything you need to know about Chicago O’Hare Airport to make your trip more organized and stress-free! Read this guide to learn about the layout, parking, and much more"
      />
      <meta
        property="og:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
      />

      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content="prestigeride.com" />
      <meta property="twitter:url" content="https://www.prestigeride.com" />
      <meta
        name="twitter:title"
        content="Chicago O’Hare International Airport – A Guide"
      />
      <meta
        name="twitter:description"
        content="Everything you need to know about Chicago O’Hare Airport to make your trip more organized and stress-free! Read this guide to learn about the layout, parking, and much more"
      />
      <meta
        name="twitter:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
      />
      <meta name="robots" content="index, follow" />
      <link
        rel="canonical"
        href="https://www.prestigeride.com/blog/chicago-o-hare-international-airport-ord"
      />

      <Navbar />
      <Hero />
      <Contetn />
      <Table />
      <Contetn2 />
      <Table2 />
      <Backforward />
      <Twako />
      <Footer />
    </div>
  );
}

export default page;
